<template>
  <div class="asset_detail">
    <a-descriptions bordered size="small">
      <a-descriptions-item label="档案件" :span="2">xxxx</a-descriptions-item>
      <a-descriptions-item label="档案件编码">xxxx</a-descriptions-item>
      <a-descriptions-item label="成文日期" :span="2">xxxx</a-descriptions-item>
      <a-descriptions-item label="整体形式">xxxx</a-descriptions-item>
      <a-descriptions-item label="密级">xxxx</a-descriptions-item>
      <a-descriptions-item label="文件类型">xxxx</a-descriptions-item>
      <a-descriptions-item label="保留期限">xxxx</a-descriptions-item>
      <a-descriptions-item label="全宗号">xxxx</a-descriptions-item>
      <a-descriptions-item label="年度">xxxx</a-descriptions-item>
      <a-descriptions-item label="门类号">xxxx</a-descriptions-item>
      <a-descriptions-item label="档案分类">xxxx</a-descriptions-item>
      <a-descriptions-item label="合同号">xxxx</a-descriptions-item>
      <a-descriptions-item label="项目代号">xxxx</a-descriptions-item>
      <a-descriptions-item label="发文/编制单位">xxxx</a-descriptions-item>
      <a-descriptions-item label="项目WBS号">xxxx</a-descriptions-item>
      <a-descriptions-item label="载体形式">xxxx</a-descriptions-item>
      <a-descriptions-item label="实体类型">xxxx</a-descriptions-item>
      <a-descriptions-item label="数量">xxxx</a-descriptions-item>
      <a-descriptions-item label="电子原文数">xxxx</a-descriptions-item>
      <a-descriptions-item label="计量单位">xxxx</a-descriptions-item>
      <a-descriptions-item label="页数">xxxx</a-descriptions-item>
      <a-descriptions-item label="流程号">xxxx</a-descriptions-item>
      <a-descriptions-item label="件号">xxxx</a-descriptions-item>
      <a-descriptions-item label="档案库房">xxxx</a-descriptions-item>
      <a-descriptions-item label="公开等级">xxxx</a-descriptions-item>
      <a-descriptions-item label="交档单位">xxxx</a-descriptions-item>
      <a-descriptions-item label="开放部门">xxxx</a-descriptions-item>
      <a-descriptions-item label="移交人">xxxx</a-descriptions-item>
      <a-descriptions-item label="开放范围">xxxx</a-descriptions-item>
      <a-descriptions-item label="归档日期">xxxx</a-descriptions-item>
      <a-descriptions-item label="关联档案的标识号">xxxx</a-descriptions-item>
      <a-descriptions-item label="档案目录是否开放">xxxx</a-descriptions-item>
      <a-descriptions-item label="关联档案" :span="2">xxxx</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { getAssetDetail } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initDetail()
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    initDetail () {
      const { model } = this
      const params = {
        anln1: model.anln1,
        bukrs: model.bukrs,
        anln2: model.anln2
      }
      console.log('initDetail')
      getAssetDetail(params).then(res => {
        if (res.status === 0) {
          this.detail = res.data
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.asset_detail{
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-descriptions{
    margin-bottom: -1px;
    .ant-descriptions-title{
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #08409F;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      padding: 0 12px;
      border-right: 1px solid #DDDDDD;
      // border-left: 1px solid #e8e8e8;
      background: #FFFFFF;
    }
    .ant-descriptions-view{
      border-radius: 0;
      width: 100%;
      border-color: #DDDDDD;
      // border-left: none;
      // border-right: none;
      .ant-descriptions-row{
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 12px;
          height: 40px;
          border-bottom: 1px solid #DDDDDD;
          border-color: #DDDDDD;
        }
        .ant-descriptions-item-label{
          background: rgba(8,64,159,0.1);
          width: calc(100% / 9);
        }
        .ant-descriptions-item-content[colspan="1"]{
          // width: 230px;
          width: calc(100% / 9 * 2);
        }
        .ant-descriptions-item-content[colspan="3"]{
          // width: 580px;
          width: calc(100% / 9 * 5);
        }
        .ant-descriptions-item-content[colspan="5"]{
          // width: 930px;
          width: calc(100% / 9 * 8);
        }
      }
      .ant-descriptions-row:last-child{
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          // border-bottom: none;
        }
      }

    }
  }
  /deep/.ant-descriptions:last-child{
    .ant-descriptions-view{
      border-bottom: none;
    }
  }
}
</style>